import o from "prop-types";
import t, { useState as b } from "react";
import f from "classnames";
import { I as v, i as y } from "./Icon-ByeAHRM4.es.js";
import { T as g } from "./index-BB-Wk85r.es.js";
import { T as _ } from "./Tooltip-CwfAdzNQ.es.js";
import { d as i, f as h } from "./warningPropType-BELHg60q.es.js";
import { r as k } from "./utils-Ci4OZEP4.es.js";
import { u as C, D as P } from "./DarkModeProvider-xoZXm3ct.es.js";
import './IconButton.css';const x = "IconButton-module__button___cQCkO", I = "IconButton-module__disabled___dyx8y", T = "IconButton-module__dark___3RQYn", l = {
  button: x,
  disabled: I,
  dark: T
}, d = (e) => {
  const [r, a] = b(!1), n = r && !e.disabled, c = () => n && e.hoverColor ? e.hoverColor : e.color, u = () => n && e.hoverAltColor ? e.hoverAltColor : e.alt_color, m = () => n && e.hoverName ? e.hoverName : e.name;
  return (
    /* eslint-disable react/button-has-type */
    /* @__PURE__ */ t.createElement(
      "button",
      {
        type: e.buttonType,
        ref: e.innerRef,
        className: f(
          l.button,
          e.className,
          e.disabled && l.disabled,
          e.darkMode && l.dark
        ),
        style: e.style,
        onClick: e.disabled ? null : e.onClick,
        onMouseOver: () => a(!0),
        onFocus: () => a(!0),
        onMouseLeave: () => a(!1),
        onBlur: () => a(!1),
        "aria-label": e.label,
        "data-icon-button": e.dataIconButton,
        tabIndex: e.tabIndex,
        "aria-haspopup": e.ariaHasPopup,
        "aria-expanded": e.ariaExpanded,
        "aria-controls": e.ariaControls,
        "aria-pressed": e.ariaPressed,
        "aria-hidden": e.ariaHidden,
        disabled: e.disabled
      },
      /* @__PURE__ */ t.createElement(
        v,
        {
          color: c(),
          alt_color: u(),
          size: e.size,
          name: m(),
          style: e.iconStyle
        }
      )
    )
  );
}, s = (e) => {
  const r = C(e.darkMode), {
    tooltipProps: { darkBg: a, ...n }
  } = e;
  return e.tooltipProps.placement !== "off" ? /* @__PURE__ */ t.createElement(P, { darkMode: !(a ?? r) }, /* @__PURE__ */ t.createElement(
    _.Hover,
    {
      ...n,
      trigger: /* @__PURE__ */ t.createElement(d, { ...e, darkMode: r }),
      short: !0
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        style: {
          whiteSpace: "nowrap"
        }
      },
      /* @__PURE__ */ t.createElement(g.Body2, { responsive: !0 }, e.label)
    )
  )) : /* @__PURE__ */ t.createElement(d, { ...e, darkMode: r });
};
s.propTypes = {
  /** the button callback */
  onClick: o.func.isRequired,
  /** the name of the icon (see possible icons in Icon stories) */
  name: o.string.isRequired,
  /** the name of the icon to use on hover (see possible icons in Icon stories) */
  hoverName: o.string,
  /** the size of the icon */
  size: o.oneOfType([o.number, o.string]),
  /** extra class names to apply to the button. */
  className: o.string,
  /** the fill color of the icon */
  color: o.string,
  /** data attribute 'data-icon-button' (can be used to target DOM element or for testing purposes)
   */
  dataIconButton: i(
    o.string,
    "instead use label prop for querying purposes in tests"
  ),
  /** the fill color of the Icon when hovering over the button. Defaults to the same value as the `color` prop. */
  hoverColor: o.string,
  /** the alt/secondary color */
  alt_color: o.string,
  /** the alt/secondary color while hovered */
  hoverAltColor: o.string,
  /** extra styles to apply to the button */
  // eslint-disable-next-line react/forbid-prop-types
  style: o.object,
  /** extra styles to apply to the icon within the button */
  // eslint-disable-next-line react/forbid-prop-types
  iconStyle: o.object,
  /** aria label */
  label: h(o.string),
  /** the tabIndex of the button */
  tabIndex: i(o.number),
  /** if disabled, the button cannot be clicked and the hover color will not be applied */
  disabled: o.bool,
  /** button's ref */
  innerRef: k,
  /** indicated a popup element after clicking the button */
  ariaHasPopup: o.oneOfType([
    o.bool,
    o.oneOf(["menu", "listbox", "tree", "grid", "dialog"])
  ]),
  /** indicates if associated control is expanded, e.g. a menu  */
  ariaExpanded: o.bool,
  /** the id of the associated control */
  ariaControls: o.string,
  /** indicates that the icon button is selected */
  ariaPressed: o.bool,
  /** indicates that the icon button is hidden from screen readers
   * should only be used in special cases (e.g. a snackbar that does
   * not receive automatic focus and closes automatically after a timeout)
   *
   */
  ariaHidden: o.bool,
  /** html type of the button */
  buttonType: o.oneOf(["button", "submit", "reset"]),
  /** props to pass to label tooltip. include offsets for tooltip body and arrow,
   * html ID attribute, closed and placement props
   * (see MRUI Tooltip component documentation)
   */
  tooltipProps: o.shape({
    xOffsetArrow: o.number,
    xOffset: o.number,
    yOffsetArrow: o.number,
    yOffset: o.number,
    id: o.string,
    closed: o.bool,
    placement: o.oneOf(["top", "bottom", "left", "right", "off"]),
    darkBg: o.bool
  }),
  /** whether or not the button appears against dark background
   * will change the color of focus state and label tooltip
   */
  darkMode: o.bool
};
s.defaultProps = {
  hoverName: null,
  size: null,
  className: void 0,
  color: y.Gray,
  hoverColor: void 0,
  alt_color: void 0,
  hoverAltColor: void 0,
  dataIconButton: void 0,
  style: {},
  iconStyle: {},
  label: void 0,
  tabIndex: void 0,
  disabled: !1,
  innerRef: void 0,
  ariaHasPopup: !1,
  ariaExpanded: void 0,
  ariaControls: void 0,
  ariaPressed: void 0,
  buttonType: "button",
  darkMode: void 0,
  tooltipProps: { placement: "off", darkBg: void 0 },
  ariaHidden: !1
};
export {
  s as I
};
